import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { func, bool } from 'prop-types';

import styles from './styles';
import AddAccount from './layout';

class AddAccountContainer extends PureComponent {
  render() {
    return (
      <div style={styles.addAccountContainer}>
        <AddAccount onSubmit={this.props.onSubmit} loading={this.props.addAccountLoading} />
      </div>
    );
  }
}

AddAccountContainer.propTypes = {
  onSubmit: func.isRequired,
  addAccountLoading: bool
};

const mapStateToProps = store => ({
  addAccountLoading: store.account.addAccountLoading
});

export default connect(mapStateToProps)(AddAccountContainer);
